const metrics = [
  ["matchingUsers", "Matching users"],
  ["eligibleInstallations", "Eligible installations"],
  ["excludedNoInstallation", "No installation"],
  ["excludedInactiveOrStale", "Inactive or stale"],
  ["excludedPermission", "Permission excluded"],
  ["excludedPreference", "Preference excluded"],
];

function AudiencePreview({ preview, loading }) {
  if (loading && !preview) {
    return <p className="text-sm text-slate-500">Refreshing audience preview…</p>;
  }
  if (!preview) {
    return (
      <p className="text-sm text-slate-500">
        Complete valid content and audience choices to preview eligibility.
      </p>
    );
  }

  return (
    <section aria-label="Audience preview">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {metrics.map(([key, label]) => (
          <div key={key} className="rounded border border-slate-200 bg-white p-3">
            <div className="text-2xl font-semibold text-slate-900">
              {preview[key] ?? 0}
            </div>
            <div className="text-xs text-slate-500">{label}</div>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-slate-500">
        Eligible installations is the delivery target. A user may have more than one installation.
      </p>
    </section>
  );
}

export default AudiencePreview;
